import React, { useRef, useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    Checkbox,
    DialogTitle,
    DialogContent,
    TableContainer,
    Button,
    Grid,
    DialogActions,
    Typography,
    Box
} from '@material-ui/core';
import { CheckCircleOutline, Close } from '@material-ui/icons';
import { moneyFormat } from 'src/utils/Common';
import { useDialog } from 'src/contexts/DialogContext';
import { SelectQuantity } from './SelectQuantity';

export function AddMaterial({
    materials = [],
    initialSelectedMaterialsIds = [],
    initalMaterialCounts = {},
    currency,
    tanentCode,
    onDone,
    onAbort
}) {
    const [filter, setFilter] = useState('');
    const [selectedMaterialIds, setSelectedMaterialIds] = useState([...initialSelectedMaterialsIds]);
    const countsRef = useRef(initalMaterialCounts);
    const { openDialog } = useDialog();

    const filteredMaterials = materials.filter(
        material =>
            material.MaterialDesc.toLowerCase().includes(filter) || material.MaterialCode.toLowerCase().includes(filter)
    );

    const handleAddMaterial = materialId => {
        openDialog(({ closeDialog }) => (
            <SelectQuantity
                onDone={quantity => {
                    if (!selectedMaterialIds.includes(materialId)) {
                        setSelectedMaterialIds(prev => [...prev, materialId]);
                    }
                    countsRef.current[materialId] = quantity;
                    closeDialog();
                }}
            />
        ));
    };

    const handleDeleteMaterial = materialId => {
        setSelectedMaterialIds(prev => prev.filter(id => id !== materialId));
        delete countsRef.current[materialId];
    };

    const handleDone = () => {
        onDone(
            materials
                .filter(material => selectedMaterialIds.includes(material.MaterialId))
                .map(material => ({
                    ...material,
                    Count: countsRef.current[material.MaterialId]
                }))
        );
    };

    return (
        <>
            <Grid container justifyContent="space-between">
                <Grid item>
                    <DialogTitle>Add Materials</DialogTitle>
                </Grid>
            </Grid>
            <DialogContent>
                <TextField
                    value={filter}
                    onChange={e => setFilter(e.target.value.toLocaleLowerCase())}
                    fullWidth
                    type="search"
                    placeholder="Enter the material code or name"
                    style={{ marginBottom: 8 }}
                ></TextField>

                <TableContainer
                    component={Paper}
                    style={{ height: 550, minWidth: 700, maxWidth: 700, overflow: 'auto', userSelect: 'none' }}
                >
                    {!filteredMaterials.length ? (
                        <Box mt={10}>
                            <Typography align="center" variant="h5">
                                No result
                            </Typography>
                        </Box>
                    ) : (
                        <Table size="small">
                            <TableBody>
                                {filteredMaterials.map(material => (
                                    <TableRow
                                        key={material.MaterialId}
                                        hover
                                        onClick={() => {
                                            selectedMaterialIds.includes(material.MaterialId)
                                                ? handleDeleteMaterial(material.MaterialId)
                                                : handleAddMaterial(material.MaterialId);
                                        }}
                                    >
                                        <TableCell>{material.MaterialCode}</TableCell>
                                        <TableCell>{material.MaterialDesc}</TableCell>
                                        <TableCell align="right" style={{ padding: 0 }}>
                                            {moneyFormat(material.Price, tanentCode, currency)}
                                        </TableCell>
                                        <TableCell>{currency}</TableCell>
                                        {/* <TableCell>{countsRef.current[material.MaterialId]}</TableCell> */}
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={selectedMaterialIds.includes(material.MaterialId)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    onClick={handleDone}
                    endIcon={<CheckCircleOutline />}
                >
                    Done
                </Button>
                <Button size="small" color="secondary" variant="outlined" onClick={onAbort} endIcon={<Close />}>
                    Abort
                </Button>
            </DialogActions>
        </>
    );
}
